import { Component, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-language-selector',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent {
  isOpen = false;
  currentLang = 'pt';

  availableLangs = ['pt', 'en', 'es', 'fr'];
  langFlags: { [key: string]: string } = {
    'pt': '🇵🇹',
    'en': '🇬🇧',
    'es': '🇪🇸',
    'fr': '🇫🇷'
  };
  langNames: { [key: string]: string } = {
    'pt': 'Português',
    'en': 'English',
    'es': 'Español',
    'fr': 'Français'
  };

  constructor(private translateService: TranslateService) {
    this.currentLang = this.translateService.currentLang || 'pt';
  }

  toggleDropdown(event: Event) {
    event.stopPropagation();
    this.isOpen = !this.isOpen;
  }

  changeLanguage(lang: string, event: Event) {
    event.stopPropagation();
    this.currentLang = lang;
    this.isOpen = false;

    this.translateService.use(lang).subscribe({
      next: () => console.log(`${lang}`),
      error: (err) => console.error('Erro ao carregar traduções:', err)
    });
  }

  @HostListener('document:click')
  closeDropdown() {
    this.isOpen = false;
  }
}
